export default "__VITE_ASSET__18ab0d31__"